<template>
  <div class="card-wrap" @mousemove="handleMouseMove" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave"
    ref="card">
    <div class="card" :style="cardStyle">
      <loader  :loading="state.isLoading" />
     <div class="card-bg" loading="lazy" :style="[cardBgTransform, cardBgImage]" :class="{nodesc: !$refs.$slots || nodesc}" ></div>
      <div class="card-info">
        <slot name="header"></slot>
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>

import { onMounted, reactive } from 'vue'
import { getFeatureMedia } from '../../scripts/getAxios'
export default {
  name: "card-item",
  props: {
    constHeight: {
      type: String,
      default:  '450px'
    },
    dataImage: {
      type: String,
      default: ''
    },
    featured:{
      type:Object,
      default: null

    }
  },
  setup(props){
    const state = reactive({
      media: null,
      isLoading:false,
    })
    const {featured, dataImage} = {...props}
    
    const FeatureMedia = async(id) =>{
      state.isLoading = true
      const res =   await  getFeatureMedia(`${process.env.WORDPRESS_BASE_URL}/wp-json/wp/v2/media/${id}`)
      state.media = res.data.guid.rendered
      state.isLoading = false
    } 
    

    onMounted( async () =>{
      dataImage ? state.media = dataImage : FeatureMedia(featured)
    })
    
    return{
      state
    }
  },
  mounted() {
    this.width = this.$refs.card.offsetWidth;
    this.height = this.$refs.card.offsetHeight;

  },

  
  data: () => ({
    width: 0,
    height: 0,
    mouseX: 0,
    mouseY: 0,
    moveMouseY: true,
    mouseLeaveDelay: null,
    

  }),
  computed: {
    mousePX() {
      return this.mouseX / this.width;
    },
    mousePY() {
      return this.mouseY / this.height;
    },
    cardStyle() {
      const rX = this.mousePX * 5;
      const rY = this.mousePY * -5;
      return {
        transform: `rotateY(${rX}deg) rotateX(${rY}deg)`
      };
    },
    cardBgTransform() {
      const tX = this.mousePX * -5;
      const tY = this.mousePY * -5;
      return {
        transform: `translateX(${tX}px) translateY(${tY}px)`
      }
    },
    cardBgImage(){ 
       this.onImgLoad =true
       return  {backgroundImage : `url(${this.state.media})`}
    }
    
  },
  methods: {
    handleMouseMove(e) {
      this.mouseX = e.pageX - this.$refs.card.offsetLeft - this.width / 2;
      this.mouseY = this.moveMouseY ? e.pageY - this.$refs.card.offsetTop - this.height / 2 : 0;
    },
    handleMouseEnter() {
      clearTimeout(this.mouseLeaveDelay);
    },
    handleMouseLeave() {
      this.mouseLeaveDelay = setTimeout(() => {
        this.mouseX = 0;
        this.mouseY = 0;
      }, 1000);
    }
  }
}


</script>
<style lang="scss" scoped>
$hoverEasing: cubic-bezier(0.23, 1, 0.32, 1);
$returnEasing: cubic-bezier(0.445, 0.05, 0.55, 0.95);




p {
  line-height: 1.5em;
}

:slotted(h1) {
  font-size: 5rem;
}

h1+p,
p+p {
  margin-top: 10px;
}

.card-wrap {
  margin: 10px;
  transform: perspective(800px);
  transform-style: preserve-3d;
  cursor: pointer;
  // background-color: #fff;

  &:hover {
    .card-info {
      transform: translateY(0);
      width:100%;
    }

    .card-info p {
      opacity: 1;
    }

    .card-info,
    .card-info p {
      transition: 0.6s $hoverEasing;
    }

    .card-info:after {
      transition: 5s $hoverEasing;
      opacity: 1;
      transform: translateY(0);
    }

    .card-bg {
      transition:
        0.6s $hoverEasing,
        opacity .3s $hoverEasing;
      opacity: 0.8;

      &.nodesc {
        opacity: 1;
      }
    }

    .card {
      transition:
        0.6s $hoverEasing,
        box-shadow 2s $hoverEasing;
      box-shadow:
        rgba(white, 0.2) 0 0 40px 5px,
        rgba(white, 1) 0 0 0 1px,
        rgba(black, 0.66) 0 30px 60px 0,
        inset #333 0 0 0 5px,
        inset white 0 0 0 6px;
    }
  }
}

.card {
  position: relative;
  width: 100%;
  height: v-bind(constHeight);
  background-color: transparent;
  overflow: hidden;
  border-radius: 10px;
  box-shadow:
    rgba(black, 0.66) 0 30px 60px 0,
    inset #333 0 0 0 5px,
    inset rgba(white, 0.5) 0 0 0 6px;
  transition: 1s $returnEasing;
}

.card-bg {
  opacity: 0.6;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition:
    1s $returnEasing,
    opacity 5s 1s $returnEasing;
  pointer-events: none;

  &.nodesc {
    opacity: 0.5;
  }
}

.card-info {
  padding: 40px 20px;
  position: absolute;
  bottom: 0;
  color: #fff;
  transform: translateY(30%);
  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
  width:100%;
  @screen lg{
    transform: translateY(14%);
  }
  p {
    opacity: 0;
    text-shadow: rgba(black, 1) 0 2px 3px;
    transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  * {
    position: relative;
    z-index: 1;
  }

  .single-actor:deep .card-info h1 {
    font-size: 5rem;
    font-weight: 700;
    text-shadow: rgba(black, 0.5) 0 10px 10px;
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom, transparent 0%, rgba(#000, 0.6) 100%);
    background-blend-mode: overlay;
    opacity: 0;
    transform: translateY(100%);
    transition: 5s 1s $returnEasing;
    z-index: -2;
  }
}
</style>